module.exports = (__webpack_require__(85942))("./node_modules/@studyportals/drawer/drawer.js");